import { createApp } from 'vue'
import './style.less'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import piniaPluginPersist from 'pinia-plugin-persist'
import 'ant-design-vue/lib/message/style/index'
import 'ant-design-vue/lib/notification/style/index'
// import UploadFile from './components/file-upload'

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersist)

app.use(router)
app.use(pinia)
// app.use(UploadFile)
app.mount('#app')
